import { Component, EventEmitter, Input, OnInit, Output, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-history-details',
  templateUrl: './customer-history-details.component.html',
  styleUrls: ['./customer-history-details.component.scss']
})
export class CustomerHistoryDetailsComponent implements OnInit {
    // For AppDialogWrapperService pattern
    @Output() dialogClosed = new EventEmitter<void>();
    @Output() cancelDialog = new EventEmitter<void>();

    @Input() data: any;
    
    // For backwards compatibility
    @Optional() public dialogRef?: any;

    newCustomerInfoByGroup : any;
    oldCustomerInfoByGroup : any;
    oldContact : any;
    newContact : any;
    oldCustomerAircrafts : any;
    newCustomerAircrafts : any;
    oldAircraft : any;
    newAircraft : any;
    oldPricingTemplate : any;
    newPricingTemplate : any;

    constructor(
        @Optional() @Inject(MatDialogRef) dialogRef?: MatDialogRef<any>,
        @Optional() @Inject(MAT_DIALOG_DATA) data?: any
    ) {
        // Backwards compatibility
        if (dialogRef) {
            this.dialogRef = dialogRef;
        }
        if (data) {
            this.data = data;
        }
    }

    ngOnInit(): void {
        if (this.data) {
            this.newCustomerInfoByGroup = this.data.newCustomerInfoByGroup;
            this.oldCustomerInfoByGroup = this.data.oldCustomerInfoByGroup;
            this.oldCustomerAircrafts = this.data.oldCustomerAircrafts;
            this.newCustomerAircrafts = this.data.newCustomerAircrafts;
            this.oldPricingTemplate = this.data.oldPricingTemplate;
            this.newPricingTemplate = this.data.newPricingTemplate;
            this.oldContact = this.data.oldContact;
            this.newContact = this.data.newContact;
            this.newAircraft = this.data.newAircaft;
            this.oldAircraft = this.data.oldAircaft;
        }
    }

    onOkClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        } else {
            this.dialogClosed.emit();
        }
    }
}
